import { useTranslation } from 'react-i18next'

import type { AvailabilityStanding } from './api'

/** The chip each standing wears, borrowed from the compliance badges: green for on offer, grey for history. */
const BADGE_BY_STANDING: Readonly<Record<AvailabilityStanding, string>> = {
  Open: 'badge--active',
  Expired: 'badge--inactive',
  Withdrawn: 'badge--inactive',
}

/** Where a posting stands — read from text as much as colour, like every chip here. */
export function StandingBadge({ standing }: { standing: AvailabilityStanding }) {
  const { t } = useTranslation()

  return <span className={`badge ${BADGE_BY_STANDING[standing]}`}>{t(`availability.standings.${standing}`)}</span>
}
